import React, { ComponentState, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { siteChartModel } from "src/dataModels/docListModel";
import { userIsSuperAdmin, userIsAdmin } from "src/helper/permission-helper";
import { ListView, ListViewHeader } from "@progress/kendo-react-listview";
import CustomSkeleton from "src/control-components/skeleton/skeleton";
import CommonListFilterItem from "./common-list-filter-item";
import { TableRowsLoader } from "src/control-components/custom-skelton";
import { HeaderComponent } from "./header-component";
import { exportDocumentReport, saveExportReportNo } from "src/redux/actions";

const DocumentsBySite = () => {
  const state: ComponentState = useSelector((states) => {
    return states;
  });
  const staffLoginInfo = useSelector(
    (state: ComponentState) => state.getStaffReducer
  );
  const isBillingManager = state.getRolePermission.isBillingManager;
  const [siteData, setSiteData] = useState<siteChartModel[]>([]);
  const { documentBySiteResp, loadingObject, documentReportId, docPayload } = state["DocumentReducer"];
  const userIsSA = userIsSuperAdmin(staffLoginInfo?.roleId);
  const showBillingAmounts = state.getRolePermission.showBillingAmounts;
  const canShowBillData = isBillingManager || userIsSA || showBillingAmounts;
  const [isShowItems, setShowItems] = useState(false);
  const dispatch = useDispatch()
  useEffect(() => {
    setSiteData([]);
    if (documentBySiteResp && documentBySiteResp?.resultData) {
      setShowItems(true);

      const sortedData = documentBySiteResp?.resultData
        ?.slice()
        .sort((a, b) => b.totDocs - a.totDocs);
      sortedData?.map((item) => {
        const totalbillValue = Number(item?.totBilled).toFixed(2);
        const formattedTotalBill = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(Number(totalbillValue));
        var obj: siteChartModel = {
          id: item?.siteId,
          siteName: item?.siteName,
          documents: item?.totDocs,
          totalUnits: item.totalUnits,
          billingAmount: canShowBillData ? formattedTotalBill : "",
        };
        setSiteData((oldItem) => [...oldItem, obj]);
      });
    }
  }, [documentBySiteResp]);

  const DocBySiteHeader = () => {
    return (
      <ListViewHeader
        style={{
          color: "#000000",
          fontSize: 30,
        }}
        className="px-3 py-2 "
      >
        <div className="row border-bottom align-middle">
          <div className="col-3">
            <h2 className="f-14">Site</h2>
          </div>
          <div className="col-3">
            <h2 className="f-14"># of Docs</h2>
          </div>
          <div className="col-3">
            <h2 className="f-14">Units</h2>
          </div>
          <div className="col-3">
            <h2 className="f-14 ">Billing Charges</h2>
          </div>
        </div>
      </ListViewHeader>
    );
  };

  const SiteItemRenderer = (props) => {
    let item = props.dataItem;
    return (
      <div
        className="row py-2 border-bottom align-middle"
        style={{ margin: 0 }}
      >
        <div className="col-3">
          {!isShowItems ? (
            <CustomSkeleton shape="text" />
          ) : (
            <span className='hover_underline'>
              <CommonListFilterItem item={{id: item.id, label: item.siteName}} type={"site"} />
            </span>
          )}
        </div>
        <div className="col-3">
          {!isShowItems ? (
            <CustomSkeleton shape="text" />
          ) : (
            <div>{item?.documents}</div>
          )}
        </div>
        <div className="col-3">
          {!isShowItems ? (
            <CustomSkeleton shape="text" />
          ) : (
            <div>{item?.totalUnits}</div>
          )}
        </div>
        <div className="col-3">
          {!isShowItems ? (
            <CustomSkeleton shape="text" />
          ) : (
            <div>{item?.billingAmount}</div>
          )}
        </div>
      </div>
    );
  };
  const exportToExcel = () => {
    dispatch(exportDocumentReport([docPayload, 5]))
    dispatch(saveExportReportNo(5))
  }

  return (
    <div className="grid-table filter-grid dash-filter-grid my-3 caseload-custom gridheight docbySite boxHeight traningList topFixHeader">
      <HeaderComponent title={'Documents by Site'} onClick={exportToExcel} isLoading={documentReportId === 5} />
      {loadingObject?.includes(8) ? (
        <TableRowsLoader rowsNum={12} />
      ) : documentBySiteResp?.resultData?.length != 0 ? (
        <ListView
          className="traningList"
          data={siteData}
          item={SiteItemRenderer}
          style={{
            width: "100%",
            display: "block",
          }}
          header={DocBySiteHeader}
        />
      ) : (
      <div className="notFoundData">
             <p>No Record found</p>
             </div>
      )}
    </div>
  );
};

export default DocumentsBySite; 